import { useCallback, useState } from 'react';
import { useResizeObserver } from '@tanium/react-use-resize-observer';

interface UseExpansionHeightProps {
  /**
   * A reference to the element that may be expanded or collapsed.
   */
  ref: (node: HTMLElement | null) => void;
  /**
   * The calculated height of the reference element.
   */
  height: number | undefined;
}

/**
 * Hook for determining the height of an element based upon whether or not it is expanded.
 */
export function useExpansionHeight(isExpanded: boolean): UseExpansionHeightProps {
  const [height, setHeight] = useState<number | undefined>(undefined);

  const containerRef = useResizeObserver(
    useCallback(
      ({ contentRect }) => {
        setHeight(isExpanded ? contentRect.height : 0);
      },
      [isExpanded],
    ),
  );

  return { ref: containerRef, height };
}
